import { ChatEvent, ChatEventType } from '@reshub/dtos';

export const getChatEvent = (chatEvents: ChatEvent[] = [], eventToFind: ChatEventType): ChatEvent | undefined =>
  chatEvents.find((chatEvent) => chatEvent.type === eventToFind);
